import React from "react";
import { useSelector } from "react-redux";
import LoginForm from "../../../features/auth/LoginForm";
import ResetPasswordForm from "../../../features/auth/ResetPasswordForm";
import PrivacyPolicy from "../../../features/home/legal/PrivacyPolicy";
import TermsConditions from "../../../features/home/legal/TermsConditions";
import DeleteAccountForm from "../../../features/auth/DeleteAccountForm";
import TransactionForm from "../../../features/transactions/transactionComponents/TransactionForm";
import TransactionPartyForm from "../../../features/transactions/transactionComponents/TransactionPartyForm";
import TransactionPropertyForm from "../../../features/transactions/transactionComponents/TransactionPropertyForm";
import TaskForm from "../../../features/tasks/taskComponents/TaskForm";
import TaskEditSimple from "../../../features/tasks/taskComponents/TaskEditSimple";
import DocAddDocumentsModal from "../../../features/docs/docComponents/docAdd/DocAddDocumentsModal";
import DocSelectFormsModal from "../../../features/docs/docComponents/docAdd/DocSelectFormsModal";
import TransactionPropertyDetails from "../../../features/transactions/transactionComponents/TransactionPropertyDetails";
import TaskViewModal from "../../../features/tasks/taskComponents/TaskViewModal";
import TransactionClientAddForm from "../../../features/transactions/transactionComponents/TransactionCientAddForm";
import TransactionClientEditForm from "../../../features/transactions/transactionComponents/TransactionClientEditForm";
import TransactionPhotoUpload from "../../../features/transactions/transactionComponents/TransactionPhotoUpload";
import TransactionEditForm from "../../../features/transactions/transactionComponents/TransactionEditForm";
import DocPrepareAddSigner from "../../../features/docs/docComponents/docPrepare/signerList/DocPrepareAddSigner";
import DocUploadForEsign from "../../../features/docs/docComponents/DocUploadForEsign";
import DocUploadModal from "../../../features/docs/docComponents/docAdd/DocUploadModal";
import PersonForm from "../../../features/people/peopleComponents/PersonForm";
import PersonView from "../../../features/people/peopleComponents/PersonView";
import SendForSigning from "../../../features/docs/docComponents/docPrepare/sendForSigning/SendForSigning";
import AnnotSignatureModal from "../../../features/parties/partyDocSign/annots/AnnotFieldSignatureModal";
import DocExtractDeadlines from "../../../features/docs/docComponents/DocExtractDeadlines";
import DocRenameModal from "../../../features/docs/docComponents/DocRenameModal";
import DocArchiveLabelModal from "../../../features/docs/docComponents/DocArchiveLabelModal";
import DocEditArchiveLabelModal from "../../../features/docs/docComponents/DocEditArchiveLabelModal";
import PartyDocSignComplete from "../../../features/parties/partyDocSign/PartyDocSignComplete";
import DocShareAgentLinking from "../../../features/docs/docComponents/DocShareAgentLinking";
import DocShareAgentLinkSuccessfull from "../../../features/docs/docComponents/DocShareAgentLinkSuccessfull";
import DocFillableByClientConfirm from "../../../features/docs/docComponents/docPrepare/DocFillableByClientConfirm";
import SaveDataToFormConfirm from "../../../features/docs/docComponents/docPrepare/SaveDataToFormConfirm";
import FormTemplateRenameModal from "../../../features/formTemplates/formTemplatesComponents/FormTemplateRenameModal";
import FormTemplatesSelectFormsModal from "../../../features/formTemplates/formTemplatesComponents/FormTemplatesSelectFormsModal";
import PartyLoginCurrentUserForm from "../../../features/parties/partyLogin/PartyLoginCurrentUserForm";
import PartyLoginNewUserForm from "../../../features/parties/partyLogin/PartyLoginNewUserForm";
import TaskShareAgentWarning from "../../../features/tasks/taskComponents/TaskShareAgentWarning";
import DeadlineTemplatesEdit from "../../../features/deadlineTemplates/deadlineTemplatesComponents/DeadlineTemplatesEdit";
import DeadlineTemplatesRename from "../../../features/deadlineTemplates/deadlineTemplatesComponents/DeadlineTemplatesRename";
import DeadlineTemplatesSelect from "../../../features/deadlineTemplates/deadlineTemplatesComponents/DeadlineTemplatesSelect";
import DeadlineTemplatesApply from "../../../features/deadlineTemplates/deadlineTemplatesComponents/DeadlineTemplatesApply";
import ClausesView from "../../../features/clauses/clausesComponents/ClausesView";
import ClausesEdit from "../../../features/clauses/clausesComponents/ClausesEdit";
import TaskTemplatesRename from "../../../features/tasks/taskTemplates/taskTemplatesComponents/TaskTemplatesRename";
import TaskTemplatesEdit from "../../../features/tasks/taskTemplates/taskTemplatesComponents/TaskTemplatesEdit";
import TaskTemplatesSelect from "../../../features/tasks/taskTemplates/taskTemplatesComponents/TaskTemplatesSelect";
import TaskDeadlineForm from "../../../features/tasks/taskComponents/TaskDeadlineForm";
import AdminLogoPhotoUpload from "../../../features/auth/AdminLogoPhotoUpload";
import TransactionDeleteConfirmModal from "../../../features/transactions/transactionComponents/TransactionDeleteConfirmModal";
import DocViewImageFileModal from "../../../features/docs/docComponents/docView/DocViewImageFileModal";
import EmailTemplatesEdit from "../../../features/emailTemplates/emailTemplatesComponents/EmailTemplatesEdit";
import EmailTemplatesRename from "../../../features/emailTemplates/emailTemplatesComponents/EmailTemplatesRename";
import EmailTemplatesSelect from "../../../features/emailTemplates/emailTemplatesComponents/EmailTemplatesSelect";
import CeCertsEdit from "../../../features/ceCerts/ceCertsComponents/CeCertsEdit";
import ManagerAgentFinancialsEditForm from "../../../features/managers/managerFinancials/managerAgentFinancials/ManagerAgentFinancialsEditForm";
import ManagerEditClosingDisbursement from "../../../features/managers/managerFinancials/ManagerEditClosingDisbursement";
import ManagerEditClosingDisbursementDynamic from "../../../features/managers/managerFinancials/ManagerEditClosingDisbursementDynamic";
import DocFillImportMlsModal from "../../../features/docs/docComponents/docFill/DocFillImportMlsModal";
import DocFillValidationModal from "../../../features/docs/docComponents/docFill/DocFillValidationModal";
import DocFillNotifyTeamModal from "../../../features/docs/docComponents/docFill/DocFillNotifyTeamModal";
import AgentSendForSigning from "../../../features/parties/partyOverview/AgentSendForSigning";
import AgentShare from "../../../features/parties/partyOverview/AgentShare";
import DocShareAgentNoClientsPrompt from "../../../features/docs/docComponents/DocShareAgentNoClientsPrompt";
import DocCustomEmailModal from "../../../features/docs/docComponents/DocCustomEmailModal";
import DocPendingNotificationModal from "../../../features/docs/docComponents/DocPendingNotificationModal";
import AgentSaveConfirmModal from "../../../features/transactions/transactionComponents/AgentSaveConfirmModal";
import UserProfilePhotoUpload from "../../../features/profiles/UserProfilePhotoUpload";
import DocCommentCreateModal from "../../../features/docs/docComments/DocCommentCreateModal";
import DocCommentViewModal from "../../../features/docs/docComments/DocCommentViewModal";
import DocCommentHistoryModal from "../../../features/docs/docComments/DocCommentHistoryModal";
import PartyDocumentPreviewModal from "../../../features/transactions/transactionComponents/PartyDocumentPreviewModal";
import BrokerageFormCustomizationModal from "../../../features/managers/managerBrokerage/brokerageComponents/BrokerageFormCustomizationModal";
import BrokerageComplianceNewTemplateModal from "../../../features/managers/managerBrokerage/brokerageComponents/BrokerageComplianceNewTemplateModal";
import ImportModal from "../../../features/import/ImportModal";
import BulkTransactionUploadModal from "../../../features/import/BulkTransactionUploadModal";
import PartyNotifyAgentModal from "../../../features/parties/partyDocFill/PartyNotifyAgentModal";
import AdminCreateFormModal from "../../../features/auth/AdminCreateFormModal";
import TransactionLinkingModal from "../../../features/transactions/transactionComponents/TransactionLinkingModal";
import DualAgentModal from "../../../features/transactions/transactionComponents/DualAgentModal";
import DualAgentCreateBuyerModal from "../../../features/transactions/transactionComponents/DualAgentCreateBuyerModal";
import DualAgentLinkExistingModal from "../../../features/transactions/transactionComponents/DualAgentLinkExistingModal";
import DualAgentProgressModal from "../../../features/transactions/transactionComponents/DualAgentProgressModal";
import ComplianceNotificationModal from "../../../features/compliance/complianceComponents/ComplianceNotificationModal";
import ComplianceDocumentPreviewModal from "../../../features/compliance/complianceComponents/ComplianceDocumentPreviewModal";
import ComplianceAssignDocumentTypeModal from "../../../features/compliance/complianceComponents/ComplianceAssignDocumentTypeModal";
import AdminComplianceTemplateModal from "../../../features/auth/AdminComplianceTemplateModal";
import DocAgentSignModal from "../../../features/docs/docComponents/DocAgentSignModal";
import DocDownloadAllOptionsModal from "../../../features/docs/docComponents/DocDownloadAllOptionsModal";
import TransactionNotifyModal from "../../../features/transactions/transactionComponents/TransactionNotifyModal";
import StrategyPricingModal from "../../../features/transactions/transactionStrategy/strategyComponents/StrategyPricingModal";
import StrategyCreditConfirmModal from "../../../features/transactions/transactionStrategy/strategyComponents/StrategyCreditConfirmModal";
import StrategyResultViewerModal from "../../../features/transactions/transactionStrategy/strategyComponents/StrategyResultViewerModal";
import StrategyListingDescriptionModal from "../../../features/transactions/transactionStrategy/strategyComponents/StrategyListingDescriptionModal";
import StrategyListingDescriptionResultViewerModal from "../../../features/transactions/transactionStrategy/strategyComponents/StrategyListingDescriptionResultViewerModal";
import PropertyIntelligenceUnlockModal from "../../../features/transactions/transactionStrategy/propertyIntelligence/PropertyIntelligenceUnlockModal";
import PropertyIntelligenceModal from "../../../features/transactions/transactionStrategy/propertyIntelligence/PropertyIntelligenceModal";
import PartyFreeTrialSignupForm from "../../../features/parties/partyAllOverview/PartyFreeTrialSignupForm";

export default function ModalManager() {
  const modalLookup = {
    LoginForm,
    ResetPasswordForm,
    PrivacyPolicy,
    TermsConditions,
    DeleteAccountForm,
    TransactionForm,
    TaskForm,
    TaskEditSimple,
    DocAddDocumentsModal,
    DocSelectFormsModal,
    TransactionPartyForm,
    TransactionPropertyForm,
    TransactionPropertyDetails,
    TaskViewModal,
    TransactionClientAddForm,
    TransactionClientEditForm,
    TransactionPhotoUpload,
    TransactionEditForm,
    DocPrepareAddSigner,
    DocUploadForEsign,
    DocUploadModal,
    PersonForm,
    PersonView,
    SendForSigning,
    AnnotSignatureModal,
    DocExtractDeadlines,
    DocRenameModal,
    DocArchiveLabelModal,
    DocEditArchiveLabelModal,
    PartyDocSignComplete,
    DocShareAgentLinking,
    DocShareAgentLinkSuccessfull,
    DocFillableByClientConfirm,
    SaveDataToFormConfirm,
    FormTemplatesSelectFormsModal,
    FormTemplateRenameModal,
    PartyLoginCurrentUserForm,
    PartyLoginNewUserForm,
    TaskShareAgentWarning,
    DeadlineTemplatesEdit,
    DeadlineTemplatesRename,
    DeadlineTemplatesSelect,
    DeadlineTemplatesApply,
    ClausesView,
    ClausesEdit,
    TaskTemplatesRename,
    TaskTemplatesEdit,
    TaskTemplatesSelect,
    TaskDeadlineForm,
    AdminLogoPhotoUpload,
    TransactionDeleteConfirmModal,
    DocViewImageFileModal,
    EmailTemplatesEdit,
    EmailTemplatesRename,
    EmailTemplatesSelect,
    CeCertsEdit,
    ManagerAgentFinancialsEditForm,
    ManagerEditClosingDisbursement,
    ManagerEditClosingDisbursementDynamic,
    DocFillImportMlsModal,
    DocFillValidationModal,
    DocFillNotifyTeamModal,
    AgentSendForSigning,
    AgentShare,
    DocShareAgentNoClientsPrompt,
    DocCustomEmailModal,
    DocPendingNotificationModal,
    AgentSaveConfirmModal,
    UserProfilePhotoUpload,
    DocCommentCreateModal,
    DocCommentViewModal,
    DocCommentHistoryModal,
    PartyDocumentPreviewModal,
    BrokerageFormCustomizationModal,
    BrokerageComplianceNewTemplateModal,
    ImportModal,
    BulkTransactionUploadModal,
    AdminCreateFormModal,
    TransactionLinkingModal,
    DualAgentModal,
    DualAgentCreateBuyerModal,
    DualAgentLinkExistingModal,
    DualAgentProgressModal,
    ComplianceNotificationModal,
    ComplianceDocumentPreviewModal,
    ComplianceAssignDocumentTypeModal,
    AdminComplianceTemplateModal,
    PartyNotifyAgentModal,
    DocAgentSignModal,
    DocDownloadAllOptionsModal,
    TransactionNotifyModal,
    PartyFreeTrialSignupForm,
    StrategyPricingModal,
    StrategyCreditConfirmModal,
    StrategyResultViewerModal,
    StrategyListingDescriptionModal,
    StrategyListingDescriptionResultViewerModal,
    PropertyIntelligenceUnlockModal,
    PropertyIntelligenceModal,
  };
  const currentModal = useSelector((state) => state.modals);
  let renderedModal;
  if (currentModal?.modalType !== "") {
    const { modalType, modalProps } = currentModal;
    const ModalComponent = modalLookup[modalType];
    renderedModal = <ModalComponent {...modalProps} />;
  }

  return <span>{renderedModal}</span>;
}
